import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[appDisableClipboard]',
    standalone: false,
})
export class DisableClipboardDirective {
    @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
        event.preventDefault();
        alert('Pasting is disabled for this field.');
    }

    @HostListener('cut', ['$event']) onCut(event: ClipboardEvent) {
        event.preventDefault();
        alert('Cutting is disabled for this field.');
    }
}
